export const extractWords = (text, number) => {
    return text.split(/\s+/).slice(0, number).join(" ").replace(/<[^>]*>/g, '');
  }